import httpClient from "@plugins/http";

const fetchTeachingActions = () => {
  return httpClient.get("/apis/teachingaction");
};

export default {
  fetchTeachingActions,
};
